import { render } from "./ProjectUsagePanel.vue?vue&type=template&id=31cd5466"
import script from "./ProjectUsagePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectUsagePanel.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ProjectUsagePanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31cd5466"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31cd5466', __exports__)) {
    api.reload('31cd5466', __exports__)
  }
  
  module.hot.accept("./ProjectUsagePanel.vue?vue&type=template&id=31cd5466", () => {
    api.rerender('31cd5466', render)
  })

}


export default __exports__